import {
  Fulfillment,
  FulfillmentDtoSchema,
  fulfillmentFromDto,
  fulfillmentToDto,
} from "@/models";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "../use-toast";
import { api } from "@/lib/api";
import { getAccommodationWithFulfillmentsQueryOptions } from "../accommodations";

export function useUpdateFulfillment(
  reservationId: string,
  opts?: {
    onSuccess?: (fulfillment: Fulfillment) => void;
    onError?: () => void;
  },
) {
  const queryClient = useQueryClient();
  const { toast } = useToast();
  return useMutation({
    mutationFn: async (fulfillment: Fulfillment) => {
      const fulfillmentResult = await api.put(
        "/api/fulfillments",
        fulfillmentToDto(fulfillment),
        FulfillmentDtoSchema,
      );

      return fulfillmentFromDto(fulfillmentResult);
    },
    onSuccess: (fulfillment) => {
      queryClient.resetQueries({
        queryKey:
          getAccommodationWithFulfillmentsQueryOptions(reservationId).queryKey,
      });
      toast({
        title: "toast.fulfillmentUpdated",
        variant: "success",
      });
      opts?.onSuccess?.(fulfillment);
    },
    onError: () => {
      toast({
        title: "toast.updateFulfillmentError",
        variant: "destructive",
      });
      opts?.onError?.();
    },
  });
}
